import { css } from 'lit';

export const q1ProjectActivationPanelStyles = css`

  :host {
    display: contents;
  }

  sl-drawer {
    --size: 30rem;
  }

  sl-drawer::part(header) {
    background: var(--theme-color-primary);
    color: var(--theme-text-color-primary);
  }
  sl-drawer::part(close-button) {
    color: var(--theme-text-color-primary);
  }
  sl-drawer::part(body) {
    padding: 1.5rem;
  }
  sl-drawer::part(footer) {
    background: var(--theme-color-primary-1);
    border-top: 1px solid var(--theme-color-primary-2);
  }

  button-bar {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    width: 100%;
  }

  p.subtitle {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--gray-8);
    line-height: 1.3em;
    margin-top: 0;
  }

  p.small {
    font-size: 0.9rem;
    font-weight: 200;
    color: var(--gray-6);
    line-height: 1.3em;
  }

  h3 {
    margin-top: 0;
  }

  sl-divider {
    margin: 2rem -1.5rem;
  }

  sl-details {
    margin: 1rem 0;
  }
  sl-details::part(content) {
    border-top: 1px solid var(--gray-2);
  }
  sl-details.current::part(base) {
    box-shadow: var(--sl-shadow-medium);
  }

  span.status-summary {
    display: flex;
    align-items: center;
    gap: 0.25rem;

    color: var(--gray-6);
    --number-bg: var(--theme-color-primary-3);
  }
  span.status-summary.current {
    font-weight: 700;

    color: var(--gray-9);
    --number-bg: var(--theme-color-primary-5);
  }
  span.status-summary.completed {
    --number-bg: var(--gray-4);
  }
  sl-details[open] span.status-summary {
    color: var(--gray-8);
  }

  span.status-summary .number {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.25rem;
    
    font-size: 0.9rem;
    font-weight: 700;
    width: 1.3rem;
    height: 1.3rem;
    
    background: var(--number-bg);
    color: white;
    border-radius: 500px;
  }

  span.status-summary.completed .label {
    font-style: italic;
    text-decoration: line-through;
  }
  sl-details[open] span.status-summary.completed .label {
    font-style: normal;
    text-decoration: none;
  }

  sl-icon.suffix {
    font-size: 1.2rem;
  }
  span.status-summary.current sl-icon.suffix {
    color: var(--theme-color-primary-6);
  }

  .checklist {
    margin-top: 1rem;
  }

  .checklist-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    
    color: var(--gray-7);
    --q1-left-space-pos: 1.5rem;
    --q1-left-space-neg: -1.5rem;
  }
  .checklist-item.checked {
    color: var(--gray-5);
    font-style: italic;
  }

  .checklist-item .label {
    flex: 1 1 auto;
    font-weight: 500;
    display: flex;
    gap: 0.25rem;
    align-items: center;

    margin-right: var(--q1-left-space-neg);
  }
  .checklist-item.checked .label {
    font-weight: 300;
    text-decoration: line-through;
  }

  .checklist-item a.action,
  .checklist-item a.action:visited {
    color: var(--gray-6);
    font-weight: 300;
    font-size: 0.9rem;
    transition: color 0.2s;
  }
  .checklist-item a.action:hover,
  .checklist-item a.action:focus {
    color: var(--gray-8);
  }

  .checklist-item sl-button {
    margin-left: var(--q1-left-space-pos);
  }

  .checklist-item sl-progress-bar {
    flex: 1 1 100%;
    margin-left: var(--q1-left-space-pos);
    --height: 1.5rem;
  }
  .checklist-item.checked sl-progress-bar {
    --track-color: var(--gray-2);
    --indicator-color: var(--gray-4);
    --label-color: var(--gray-0);
  }

`;
